import "./index.css";
import "bootstrap/dist/css/bootstrap.min.css"; // Bootstrap first

import Header from "./component/Header";
import LoanForm from "./component/LoanForm";
import StudentStories from "./component/StudentStories";
import Footer from "./component/Footer";
import LoanAdvantages from "./component/LoanAdvantages";
import StudyPlan from "./component/StudyPlan";
import ApplyNow from "./component/ApplyNow";

import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import theme from "./theme";
import StudyAbroadStats from "./component/StudyAbroadStats";

const App = () => {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <div className="App">
        <Header />
        <LoanForm />
        <StudyAbroadStats />
        {/* <StudyPlan />
        <StudentStories />
        <LoanAdvantages />
        <ApplyNow />
        <Footer /> */}
      </div>
    </ThemeProvider>
  );
};

export default App;
